import { ThemeToggle } from "@/components/theme/ThemeToggle";
import { LanguageSwitcher } from "@/components/layout/LanguageSwitcher";
import { LoginForm } from "@/components/auth/LoginForm";
import { LoginHeader } from "@/components/auth/LoginHeader";
import { BrandLogo } from "@/components/auth/BrandLogo";
import { AuthRedirector } from "@/components/auth/AuthRedirector";
import { AppVersionTag } from "@/components/common/AppVersionTag";
import { useAuth } from "@/contexts/AuthContext";
import { LoginBackground } from "@/components/auth/LoginBackground";

const Login = () => {
  const { loading } = useAuth();

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="login-shell relative h-screen overflow-hidden flex flex-col">
      <LoginBackground />
      <div className="login-toolbar fixed top-0 right-0 z-50 flex items-center gap-3 px-4 pt-[calc(env(safe-area-inset-top)+1rem)]">
        <ThemeToggle />
        <LanguageSwitcher />
      </div>

      <main className="relative z-10 flex-1 flex flex-col items-center justify-center px-5 pt-[calc(env(safe-area-inset-top)+4.5rem)] pb-[calc(env(safe-area-inset-bottom)+1rem)] overflow-y-auto">
        <BrandLogo framed />
        <section className="login-card w-full max-w-md">
          <LoginHeader />
          <div className="px-6 pb-6">
            <LoginForm />
          </div>
        </section>
        <AppVersionTag className="login-version mt-6" />
      </main>

      <AuthRedirector />
    </div>
  );
};

export default Login;
